import { useEffect } from 'react';
import { IFetchStatus } from 'types/rest/IFetchStatus';

// Because this bases if it does something on the fetch status, which is shared, this hook
//  is intented to do a thing once and share the results between all users of that "slice".
//  So action will usually be something to get the data and set fetching/fetched to true.
export const useDoActionOnceBasedOnFetchStatus = (action: () => void, fetchStatus: IFetchStatus) => {
  useEffect(() => {
    if (!fetchStatus.fetching && !fetchStatus.fetched) {
      action();
    }
  }, [fetchStatus, action]);
};
